import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import {
  LOAD,
  LOAD_END,
} from "../../../../../../../store/actions/actionsTypes";
import { Drivers } from "../../../../../../modules/API/Drivers/drivers";
import { IKavDataItem } from "../../../../../../modules/API/Drivers/models/kavData";
import { IPackageLogData } from "../../../../../../modules/API/Drivers/models/packageLogData";

export interface IUsePackageStatistic {
  dataPackageLog: IPackageLogData[] | null;
  kavInfo: IKavDataItem | null;
  isOpenStatisticModal: boolean;
  handleOpenPackageStatisticModal: () => void;
  getPackageStatisticByKav: (item: IKavDataItem) => Promise<void>;
  packageLogProps: { list: IPackageLogData[] | null };
}

export const usePackageStatistic = (deps: {
  date: string;
  isOffice: boolean;
}): IUsePackageStatistic => {
  const { date, isOffice } = deps;
  const dispatch = useDispatch();
  const [dataPackageLog, setDataPackageLog] = useState<IPackageLogData[] | null>(
    null
  );
  const [kavInfo, setKavInfo] = useState<IKavDataItem | null>(null);
  const [isOpenStatisticModal, setIsOpenStatisticModal] = useState(false);

  const handleOpenPackageStatisticModal = useCallback(() => {
    setIsOpenStatisticModal((prev) => !prev);
  }, []);

  const getPackageStatisticByKav = useCallback(
    async (item: IKavDataItem) => {
      if (!isOffice) return;
      dispatch({ type: LOAD });
      try {
        const res = await Drivers.getPackageLogByKav(item.AreaID, date);
        setDataPackageLog(res);
        setKavInfo(item);
        setIsOpenStatisticModal(true);
      } catch {
        // легаси молча проглатывал ошибку
      } finally {
        dispatch({ type: LOAD_END });
      }
    },
    [dispatch, date, isOffice]
  );

  return {
    dataPackageLog,
    kavInfo,
    isOpenStatisticModal,
    handleOpenPackageStatisticModal,
    getPackageStatisticByKav,
    packageLogProps: { list: dataPackageLog },
  };
};

export default usePackageStatistic;
